import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: {
          base: "#284980",
          darken1: "#a1bfdb",
          lighten1: "#219ee8"
        },
        secondary: "#ffffff",
        accent: "#219ee8",
        error: "#d10000",
        info: "#33b5e5",
        success: "#00C851",
        warning: "#ffbb33"
      }
    }
  }
});
